module.exports = __webpack_public_path__ + "img/new_close.b3d7de9f.svg";